import QuestionPage from "./QuestionPage";

function App() {
  return <QuestionPage/>;
}

export default App;
